import React, {useRef, useState} from 'react';
import {GoogleMap, InfoWindow, Marker, withGoogleMap} from "react-google-maps";
import Utils from "../../common/Utils";
import {renderStatus as StatusRender, TimeRangeInfo} from "../Request/RequestCommon";
import CurrencyLabel from "../../components/CurrencyLabel/CurrencyLabel";
import TimeAgo from "../../common/TimeAgo";
import {Badge, Card, Col, FormGroup, InputGroup, InputGroupAddon, Row, UncontrolledTooltip} from "reactstrap";
import NumberLabel from "../../components/NumberLabel/NumberLabel";
import _ from 'lodash';
import {ComparisonOperators, ComparisonSelect} from "../../components/CRUDView/Components/ComparisonSelect";
import {RequestPaymentStatus} from "../../common/Constants";
import moment from "moment";
import {CustomFilterFrame} from "../../components/CRUDView";
import ClearButton from "../../components/CRUDView/Components/ClearButton";
import {Async as AsyncSelect, components} from "react-select";
import TwoLineItemRender from "../../components/Elements/TwoLineItemRender";
import {PaymentsEndpoints} from "../../common/ProxyEndpoints";
import Button from "reactstrap/es/Button";
import AppVariables from '../../common/AppVariables';
import TTLProxy from "../../common/TTLAsyncProxy";
import ReactRating from "react-rating";
import HistoryLink from "../../common/HistoryLink";
import {ExpanderView, SectionedList} from "../../components/AuditExplorer/Elements";
import DataList from "../../components/TableListView/DataList";
import LoadingView from "../../components/Elements/LoadingView";
import ErrorView from "../../components/Elements/ErrorView";
import HTML from '../../common/HtmlHelpers';
import {css} from "glamor";
import SmartDialog from "../../components/SmartDialog";
import {getStatusFiltersForRole, RequestStatusFilter} from "../Request/RequestStatusConfiguration";

export const SearchProps = [
    'id',
    'order_id' ,
    'name',
    'location',
    'phone' ,
    'hectares',
    'service.name'
];

const paymentRowStyle = css({
    color: '#000000',
    backgroundColor: '#FFF',
    '&:hover': {
        backgroundColor: '#000000',
        color: '#FFF'
    }
});


/**
 * Renders google map
 */
const MapView = withGoogleMap( props => (
        <GoogleMap
            ref={props.onMapLoad}
            defaultZoom={props.defaultZoom}
            defaultCenter={ props.center }
            onClick={props.onMapClick}
            onDrag={props.onDrag}
            onDragStart={props.onDragStart}
            defaultOptions={props.defaultOptions}
            onDragEnd={props.onDragEnd}
            onDblClick={props.onDoubleClick}
            onCenterChanged={props.onCenterChanged}>
            {props.markers.filter(i => Utils.isValidLocation(i.location)).map((request,id) => {
                return (<Marker position={request.location}
                                title={request.title}
                                key={id}
                                onClick={request.onClick}
                                clickable={!!request.onClick}
                                options={{
                                    icon: props.icon
                                }}>
                    {request.title && <InfoWindow>
                        <div>
                            <h5>{request.title}</h5>
                        </div>
                    </InfoWindow>}
                </Marker>);
            })}

        </GoogleMap>
    )
);

export const parseAcreageFilters = (filters) => {

    const getSelectOption = (entity,queryKey,filterKey) => {
        const _key = filterKey || `${entity}.id`;
        const _name = filters[queryKey || `${entity}Name`];
        return filters[_key] ? { label: _name , value: filters[_key]  , instance: { id : filters[_key] , name: _name } } : null ;
    };

    return {
        orderId: filters.orderId || '',
        location: filters.location || '',
        quantity: filters.hectares || '',
        quantityOperator: filters.quantityOperator || '=',
        cost: filters.cost || '',
        costOperator: filters.costOperator || '=',
        tractor: getSelectOption('tractor'),
        name: filters.name || '',
        phone: filters.phone || '',
        farmer: getSelectOption('farmer'),
        commission: filters.commission || '',
        commissionOperator: filters.commissionOperator || '=',
        payout: filters.payout || '',
        payoutOperator: filters.payoutOperator || '=',
        tractorOperator: getSelectOption('tractor_operator','tractorOperatorName'),
    };

};

export const getAcreageFilters = ({ findServiceName }) => {
    return [
        {
            key: 'orderId',
            filterKey: 'order_id',  // http request filter query key
            operator: '[]',
            query: "order_id",
            apply: true
        },
        {
            key: 'phone',
            operator: '[]',
            query: 'request_phone',
            apply: true // indicates this filter should be applied to real query
        },
        {
            key: 'name',
            operator: '[]',
            query: 'request_farmer_name',
            apply: true // indicates this filter should be applied to real query
        },
        {
            key: 'cost',
            query: 'request_cost',
            operator: filters => filters.costOperator || "=",
            apply: true,
            fromQuery: value => isFinite(value) ? Number(value) : undefined
        },
        {
            key: 'costOperator',
            query: 'cost_op',
            fromQuery: value => !!ComparisonOperators.find(x => x.symbol) ? value : undefined
        },
        {
            key: 'quantityOperator',
            query: 'quantity_op',
            fromQuery: value => !!ComparisonOperators.find(x => x.symbol) ? value : undefined
        },
        {
            key: 'commissionOperator',
            query: 'commission_op',
            fromQuery: value => !!ComparisonOperators.find(x => x.symbol) ? value : undefined
        },
        {
            key: 'payoutOperator',
            query: 'payout_op',
            fromQuery: value => !!ComparisonOperators.find(x => x.symbol) ? value : undefined
        },
        {
            key: 'tractor.id',
            query: 'tractor_id',
            apply: true
        },
        {
            key: 'tractorName',
            query: '_tractor_select_name'
        },
        {
            key: 'tractor_operator.id',
            query: "tractor_operator",
            apply: true
        },
        {
            key: "tractorOperatorName",
            query: "_operator_select_name"
        },
        {
            key: 'location',
            operator: '[]',
            query: 'request_location',
            apply: true
        },
        {
            key: 'service.id',
            name: "Service",
            query: 'request_service_type',
            apply: true,
            renderValue: value => {
                return findServiceName(value);
            }
        },
        {
            key: "requestType",
            query: "request_type",
            name: "Request Type",
            fromQuery: value => {

                switch ((value || "").toLowerCase()) {
                    case "hiring":
                    case "booking":
                        return value.toLowerCase();
                }

            },
            renderValue: value => {

                switch (value) {
                    case "hiring":
                        return "Hiring";
                    case "booking":
                        return "Booking";
                }
            }
        },
        {
            key: 'status',
            name: "Status",
            query: 'request_status',
            fromQuery: value => {

                const filters = getStatusFiltersForRole(TTLProxy.getInstance().getUserRole());
                let _val = (value || "").toLowerCase();
                let frame = _val ? filters.find(x => x.value === _val) : null;
                if(frame){
                    return frame.value;
                }

            },
            renderValue: value => {

                const frame = RequestStatusFilter.find(x => x.value === value);
                if(frame){
                    return frame.text;
                }

            }
        },
        {
            key: 'hectares',
            query: 'request_quantity',
            operator: filters => filters.quantityOperator || "=",
            apply: true
        },
        {
            key: 'commission',
            query: 'commission',
            operator: filters => filters.commissionOperator || "=",
            apply: true,
            fromQuery: value => isFinite(value) ? Number(value) : undefined
        },
        {
            key: 'payout',
            query: 'payout',
            operator: filters => filters.payoutOperator || "=",
            apply: true,
            fromQuery: value => isFinite(value) ? Number(value) : undefined
        },
        {
            key: 'farmer.id',
            filterKey: "farmer_id",
            query: 'farmer_id',
            apply: true
        },
        {
            key: 'farmerName',
            query: "_farmer_select_name"
        },
        {
            key: "timeFrame",
            query: "_frame",
            name: "Date Range",
            dependencies: [ 'timeRangeStart' , 'timeRangeEnd' ],    //  remove these dependencies when filter chip is deleted
            fromQuery: value => Object.keys(TimeRangeInfo).includes(value) ? value : undefined,
            renderValue: (value,filters) => {

                if(value === "custom"){

                    if(filters.timeRangeStart && filters.timeRangeEnd){
                        return `${moment(filters.timeRangeStart).format('L')} - ${moment(filters.timeRangeEnd).format('L')}`;
                    }

                }

                return TimeRangeInfo[value].text;
            }
        },
        {
            key: "timeRangeStart",
            query: "_from",
            toQuery: value => !_.isNil(value) &&  moment(value).isValid() ? moment(value).toJSON() : undefined,
            fromQuery: value => {

                let date = moment(value);
                if(!_.isNil(value) && date.isValid())
                    return date.toDate();

                return null;
            }
        },
        {
            key: "timeRangeEnd",
            query: "_to",
            toQuery: value => !_.isNil(value) && moment(value).isValid() ? moment(value).toJSON() : undefined,
            fromQuery: value => {

                let date = moment(value);
                if(!_.isNil(value) && date.isValid())
                    return date.toDate();

                return null;
            }
        }
    ]
};

export const CustomAcreageFilters = ({   fetchFarmers,
                                         fetchOperators,
                                         fetchTractors,
                                         applyFilters ,
                                         toggle,
                                         values ,
                                         setValue ,
                                         setValues ,
                                         resetValues }) => {

    const segmentParts = (parts,size) => {

        let final = [];
        let temp = [];
        let i = 0,  len = parts.length;
        while (i < len) {

            if (i > 0 && i % size === 0) {
                final.push(temp);
                temp = [];
            }
            temp.push(parts[i]);
            i++;
        }

        if(temp.length > 0)
            final.push(temp);

        return final;
    };
    const proxy = TTLProxy.getInstance();
    let parts = [

        <React.Fragment>

            <b>Order ID</b>
            <input name="orderId"
                   value={values['orderId']}
                   onChange={evt => {
                       setValue('orderId',evt.target.value);
                   }}
                   type="text"
                   className="form-control form-input-select"
                   placeholder="Request order id"/>

        </React.Fragment>,

        <React.Fragment>

            <b>Location</b>
            <input name="location"
                   value={values['location']}
                   onChange={evt => {
                       setValue('location',evt.target.value);
                   }}
                   type="text"
                   className="form-control form-input-select"
                   placeholder="Request location"/>


        </React.Fragment>,

        <React.Fragment>

            <b>Quantity</b>
            <FormGroup>
                <InputGroup>


                    <input name="quantity"
                           value={values['quantity']}
                           onChange={evt => {
                               setValue('quantity',evt.target.value);
                           }}
                           type="number"
                           className="form-control form-input-select"
                           placeholder="Request quantity"/>

                    <InputGroupAddon addonType="prepend">
                        <ComparisonSelect value={values['quantityOperator']} onChange={operator => setValue('quantityOperator',operator)}/>
                    </InputGroupAddon>

                </InputGroup>
            </FormGroup>


        </React.Fragment>,

        <React.Fragment>
            <b>Cost</b>
            <FormGroup>
                <InputGroup>

                    <input name="cost"
                           value={values['cost']}
                           onChange={evt => {
                               setValue('cost',evt.target.value);
                           }}
                           type="number"
                           className="form-control form-input-select"
                           placeholder="Request cost"/>

                    <InputGroupAddon addonType="prepend">
                        <ComparisonSelect value={values['costOperator']} onChange={operator => setValue('costOperator',operator)}/>
                    </InputGroupAddon>

                </InputGroup>
            </FormGroup>

        </React.Fragment>
    ];

    if(fetchTractors){
        parts = parts.concat([
            <React.Fragment>
                <div className="clearfix">
                    <b className="pull-left">Tractor</b>
                    <div className="pull-right">
                        <ClearButton onClick={() => setValues({
                            tractor: null,
                            tractorName: null
                        })}/>
                    </div>
                </div>
                <AsyncSelect  name="tractor"
                              defaultOptions
                              cacheOptions
                              placeholder="Select tractor..."
                              value={values['tractor']}
                              onChange={value => {
                                  setValue('tractor',value);
                              }}
                              components={{
                                  Option: ({ children , ...props }) => {

                                      const tractor = props.data.instance;
                                      return <components.Option {...props}>

                                          <TwoLineItemRender media={tractor.media}
                                                             line1Value={`${tractor.name} (${tractor.registration_number})`}
                                                             line2Prefix="Chassis"
                                                             line2Value={tractor.chassis}/>

                                      </components.Option>

                                  }
                              }}
                              loadOptions={async (value) => {

                                  try {

                                      const res = await proxy.processRequest( fetchTractors({
                                          search: { keyword: value , method: 'inside', fields: ['name','chassis', 'registration_number' ] },
                                          pagination: { page: 1 , perPage : 5 },
                                          include: [ 'media' ]
                                      }));

                                      return res.getPayload().map(t => ({ label: "" , value: t.id  , instance: t }));
                                  }
                                  catch (e) {

                                  }

                              }}/>
            </React.Fragment>,

            <React.Fragment>

                <b>Commission</b>

                <FormGroup>
                    <InputGroup>

                        <input name="commission"
                               value={values['commission']}
                               onChange={evt => {
                                   setValue('commission',evt.target.value);
                               }}
                               type="number"
                               min={0}
                               className="form-control form-input-select"
                               placeholder="Commission"/>

                        <InputGroupAddon addonType="prepend">
                            <ComparisonSelect value={values['commissionOperator']} onChange={operator => setValue('commissionOperator',operator)}/>
                        </InputGroupAddon>

                    </InputGroup>
                </FormGroup>

            </React.Fragment>,

            <React.Fragment>

                <b>Amount Received</b>

                <FormGroup>
                    <InputGroup>

                        <input name="payout"
                               value={values['payout']}
                               onChange={evt => {
                                   setValue('payout',evt.target.value);
                               }}
                               type="number"
                               min={0}
                               className="form-control form-input-select"
                               placeholder="Amount received"/>

                        <InputGroupAddon addonType="prepend">
                            <ComparisonSelect value={values['payoutOperator']} onChange={operator => setValue('payoutOperator',operator)}/>
                        </InputGroupAddon>

                    </InputGroup>
                </FormGroup>

            </React.Fragment>
        ]);
    }

    if(fetchFarmers){

        parts = parts.concat([

            <React.Fragment>

                <b>Name</b>
                <input name="name"
                       value={values['name']}
                       onChange={evt => {
                           setValue('name',evt.target.value);
                       }}
                       type="text"
                       className="form-control form-input-select"
                       placeholder="Farmer name"/>

            </React.Fragment>,

            <React.Fragment>

                <div className="clearfix">
                    <b className="pull-left">Farmer</b>
                    <div className="pull-right">
                        <ClearButton onClick={() => setValues({
                            farmer: null,
                            farmerName: null
                        })}/>
                    </div>
                </div>

                <AsyncSelect  name="farmer"
                              defaultOptions
                              cacheOptions
                              placeholder="Select farmer..."
                              value={values['farmer']}
                              onChange={value => {
                                  setValue('farmer',value);
                              }}
                              components={{
                                  Option: ({ children , ...props }) => {

                                      const farmer = props.data.instance;
                                      return <components.Option {...props}>

                                          <TwoLineItemRender  media={farmer.media}
                                                              line1Value={farmer.name}
                                                              line2Prefix="Phone"
                                                              line2Value={farmer.phone}/>

                                      </components.Option>

                                  }
                              }}
                              loadOptions={async (value) => {

                                  try {

                                      const res = await proxy.processRequest( fetchFarmers({
                                          search: { keyword: value , method: 'inside', fields: ['name' , 'phone' , 'user.email', 'user.phone' ] },
                                          pagination: { page: 1 , perPage : 5 },
                                          include: [ 'media' , 'user' ]
                                      }));

                                      return res.getPayload().map(t => ({ label: t.name , value: t.id  , instance: t }));
                                  }
                                  catch (e) {

                                      // failed to load query

                                  }

                              }}/>

            </React.Fragment>
        ]);
    }

    if(fetchOperators){

        parts.push(<React.Fragment>

            <div className="clearfix">
                <b className="pull-left">Tractor Operator</b>
                <div className="pull-right">
                    <ClearButton onClick={() => setValues({
                        tractorOperator: null,
                        tractorOperatorName: null
                    })}/>
                </div>
            </div>

            <AsyncSelect  name="tractorOperator"
                          defaultOptions
                          cacheOptions
                          placeholder="Select tractor operator..."
                          value={values['tractorOperator']}
                          onChange={value => {
                              setValue('tractorOperator',value);
                          }}
                          components={{
                              Option: ({ children , ...props }) => {

                                  const operator = props.data.instance;
                                  return <components.Option {...props}>

                                      <TwoLineItemRender  media={operator.media}
                                                          line1Value={operator.name}
                                                          line2Prefix="Phone"
                                                          line2Value={operator.phone}/>

                                  </components.Option>

                              }
                          }}
                          loadOptions={async (value) => {

                              try {

                                  const res = await proxy.processRequest( fetchOperators({
                                      search: { keyword: value , method: 'inside', fields: [ 'name' , 'email', 'phone' ] },
                                      pagination: { page: 1 , perPage : 5 },
                                      include: [ 'media' ]
                                  }));

                                  return res.getPayload().map(t => ({ label: t.name , value: t.id  , instance: t }));
                              }
                              catch (e) {

                                  // failed to load query

                              }

                          }}/>

        </React.Fragment>);
    }


    return  <CustomFilterFrame toggle={toggle}>

        {segmentParts(parts,4).map((frame,fk) => (<Row key={fk} className="mb-1">
            {frame.map((section,sk) => (<Col key={sk} md={3}>{section}</Col>))}
        </Row>))}

        <hr/>

        <div className="clearfix">

            <div className="pull-left">
                <Button onClick={() => resetValues() }><i className="fa fa-refresh"/> Reset Filters</Button>
            </div>

            <div className="pull-right">
                <Button color="green" style={{ borderRadius: 4 }} onClick={() => {

                    let _targetFilter = { };
                    Object.keys(values).forEach(k => {

                        let _v = values[k];
                        let _initialValue = _v;

                        switch (k) {
                            case "farmer":
                                k = "farmer.id";
                                _v = !_.isNil(_v) ? _v.instance.id : null;
                                _targetFilter['farmerName'] = _v ? _initialValue.instance.name : undefined;
                                break;
                            case "tractor":
                                k = "tractor.id";
                                _v = !_.isNil(_v) ? _v.instance.id : null;
                                _targetFilter['tractorName'] = _v ? _initialValue.instance.name : undefined;
                                break;
                            case "tractorOperator":
                                k = "tractor_operator.id";
                                _v = !_.isNil(_v) ? _v.instance.id : null;
                                _targetFilter['tractorOperatorName'] = _v ? _initialValue.instance.name : undefined;
                                break;
                            case "quantity":
                                k = "hectares";
                                break;

                        }

                        if(!_.isNil(_v) && _v !== ""){
                            _targetFilter[k] = _v;
                        }
                        else{
                            _targetFilter[k] = undefined;
                        }

                    });

                    applyFilters(_targetFilter);


                }}><i className="fa fa-check"/> Apply</Button>
            </div>
        </div>

    </CustomFilterFrame>

};

/**
 * Shows Payments Made for tractor request
 * @return {*}
 * @constructor
 */
const PaymentsView = ({ request , filter , showStatusColumn , confirmationStatusMode = 'readonly' }) => {

    const [{ isExpanded , data , isBusy  , error, paymentInfo },setState] = useState({
        isExpanded: false,
        data: false,
        isBusy: false,
        error: null,
        paymentInfo: null
    });

    const filterPayments = (payments) => {
        return filter ? filter(payments) : payments;
    };

    const includeModels = [
        { model: 'owner' },
        { model: 'tractor_request' },
        { model: 'wallet' }
    ];

    const listRef = useRef();
    const infoDlgRef = useRef();
    const proxy = TTLProxy.getInstance();

    const PaymentStatus = ({ status }) => {

        let content;
        switch (status) {
            case RequestPaymentStatus.Success:
                content = <Badge pill color="success">Successful</Badge>;
                break;
            case RequestPaymentStatus.Failed:
                content = <Badge pill color={"warning"}>Failed</Badge>;
                break;
            case RequestPaymentStatus.Cancelled:
                content = <Badge pill color={"danger"}>Cancelled</Badge>;
                break;
        }

        return <h6>{content}</h6>
    };

    const PaymentInfoDialog = ({ paymentInfo , dlgRef }) => {

        return <SmartDialog ref={dlgRef} title="Payment Info" large>

            {paymentInfo && <div>

                <SectionedList items={[
                    {
                        title: "Reference",
                        value: paymentInfo.local_reference
                    },
                    {
                        title: "Amount",
                        value: paymentInfo.amount
                    },
                    {
                        title: "Currency",
                        value: paymentInfo.currency
                    },
                    {
                        title: "Wallet",
                        value: `${paymentInfo.receiver_account_name} - ${paymentInfo.receiver_account_no}`
                    },
                    {
                        title: "Status",
                        value: <PaymentStatus status={paymentInfo.status}/>
                    },
                    {
                        title: "Time Issued",
                        value: Utils.formatDateStandard(paymentInfo.date_created)
                    },
                    {
                        title: "Comments",
                        mode: "vertical",
                        value: paymentInfo.comments
                    },

                ]}/>

            </div>}

        </SmartDialog>

    };

    let columns = [
        {
            key: "amount",
            label: "Amount",
            render: item => {
                return <CurrencyLabel value={item.amount} currency={item.currency}/>
            }
        },
        {
            key: "wallet",
            label: "Wallet",
            render: item => {

                const id = `payment_wallet_${item.id}`;
                const { wallet } = item;

                return <React.Fragment>
                        <span id={id} className="btn-link">{item.receiver_account_no}</span>
                        <UncontrolledTooltip target={id} placement="bottom" fade={false}>

                            <div className="text-left">
                                <span><b>Name:</b> {wallet.name}</span><br/>
                                <span><b>Provider:</b> {wallet.provider.toUpperCase()}</span><br/>
                                <span><b>Value:</b> {wallet.value}</span><br/>
                                <span><b>Is Default:</b> {wallet.is_default ? "True" : "False"}</span>
                            </div>

                        </UncontrolledTooltip>
                    </React.Fragment>;
            }
        }
    ];

    if(showStatusColumn){

        columns.push({
            key: "status",
            label: "Status",
            render: item => {
               return <PaymentStatus status={item.status}/>;
            }
        });

    }

    columns = columns.concat([
        {
            key: "time",
            label: "Time",
            render: item => {
                return Utils.formatDateStandard(item.date_created)
            }
        },
        {
            key: "acknowledge",
            label: "Confirmation",
            render: item => {

                const id = `payment_confirmation_${item.id}`;

                const renderAcknowledgedStatus = () => {

                    return <React.Fragment>

                        <span id={id} style={{ color: "#00c157" }}> <i className="fa fa-check"/></span>

                        <UncontrolledTooltip target={id} placement="bottom" fade={false}>
                            {Utils.formatDateStandard(item.time_acknowledged)}
                        </UncontrolledTooltip>

                    </React.Fragment>;

                };

                let content;
                switch (confirmationStatusMode) {

                    case 'readonly':
                        content = item.time_acknowledged ? renderAcknowledgedStatus() : "NOT YET";
                        break;
                    case 'editable':
                        content = item.time_acknowledged ? renderAcknowledgedStatus() : <Button size="sm" title="Click to confirm payment received" onClick={async () => {

                                if(window.confirm('Please confirm payment received?')){

                                    try{

                                        if((await proxy.processRequest(PaymentsEndpoints.acknowledgePayment(item.id))).ok){

                                            //  toast message
                                            HTML.toastSuccess('Payment confirmed successfully');

                                            //
                                            const payment = (await proxy.processRequest({
                                                ...PaymentsEndpoints.get(item.id),
                                                include: includeModels
                                            })).getPayload();

                                            //
                                            const index = data.payments.indexOf(item);
                                            if(index >= 0){

                                                data.payments[index] = payment;

                                                setState(state => ({
                                                    ...state,
                                                    data
                                                }));

                                            }


                                        }

                                    }
                                    catch (e) {

                                        HTML.toastError(Utils.getResponseError(e));

                                    }
                                }

                            }}><i className="fa fa-check"/> Confirm</Button>;
                        break;
                }

                return <div className="text-center">
                    {content}
                </div>
            }
        }
    ]);



    return <ExpanderView onExpand={async () => {

        if(isExpanded){

            setState(state => ({
                ...state,
                isBusy: false,
                error: null
            }));

            try {

                const response = await proxy.processRequest({
                    ...PaymentsEndpoints.getRequestPaymentInfo(request.id),
                    include: includeModels
                });

                setState(state => ({
                    ...state,
                    data: response.getPayload()
                }));

            }
            catch (e) {

                setState(state => ({
                    ...state,
                    error: Utils.getResponseError(e)
                }));

            }
            finally {

                setState(state => ({
                    ...state,
                    isBusy: false,
                    isExpanded: true
                }));

            }

        }
    }}>

        <div className="p-2" style={{ backgroundColor: "#efefef" }}>

            <LoadingView isBusy={isBusy}>

                <ErrorView error={error}>

                    <Card body style={{ backgroundColor: "white" , color: "black" , boxShadow: '0 2px 2px #FFF' }}>

                            <PaymentInfoDialog dlgRef={infoDlgRef} paymentInfo={paymentInfo}/>

                            <CustomFilterFrame>
                                <span style={{ fontSize: "medium" }}><b>Total Amount:</b> <CurrencyLabel value={data.totalSucceededAmount} currency={request.currency}/></span>
                            </CustomFilterFrame>

                            <DataList listRef={listRef}
                                      itemsPerPage={5}
                                      noRowsMessage={"No payments issued yet!"}
                                      hover
                                      responsive
                                      onRowClick={item => {

                                          setState(state => ({
                                              ...state,
                                              paymentInfo: item
                                          }),() => {
                                             infoDlgRef.current.show();
                                          });

                                      }}
                                      defaultRowClass={`${paymentRowStyle}`}
                                      columns={columns}
                                      data={filterPayments(data.payments || [])}/>
                    </Card>


                </ErrorView>

            </LoadingView>



        </div>


    </ExpanderView>;
};

export const DetailView = ({   request ,
                               showFarmer,
                               showOperator,
                               showIncome,
                               showCommission ,
                               toggle,
                               defaultCoordinate =  AppVariables.DefaultMapCoordinates }) => {

    let markers = [];
    let coord = { lat: request.location_lat , lng: request.location_long };

    if(Utils.isValidLocation(coord)){

        markers.push({
            title: request.location,
            location: coord
        });

    }
    else{
        coord = defaultCoordinate;
    }

    return <div>

        <div className="row">

            <div className="col-md-6">
                <dl>
                    <dt>Request Id</dt>
                    <dd>{request.order_id}</dd>

                    {showFarmer && <React.Fragment>
                        <dt>Farmer Name</dt>
                        <dd>{request.name}</dd>
                    </React.Fragment>}

                    <dt>Location</dt>
                    <dd>{request.location}</dd>

                    <dt>Request Status</dt>
                    <dd>{StatusRender(request)}</dd>


                    <dt>Payment Status</dt>
                    <dd>{HTML.renderTransactionStatus(request)}</dd>

                </dl>
            </div>

            <div className="col-md-6">

                <dl>

                    <dt>Service</dt>
                    <dd>{request.service.name}</dd>

                    <dt>Quantity</dt>
                    <dd><NumberLabel value={request.hectares}/> {Utils.pluralize(request.hectares,request.service.unit_name.toLowerCase())}</dd>

                    <dt>Cost</dt>
                    <dd><CurrencyLabel value={request.cost}/></dd>

                    <dt>Rating</dt>
                    <p>{request.operator_rating ?  <ReactRating readonly
                                                                emptySymbol="fa fa-star-o"
                                                                fullSymbol="fa fa-star"
                                                                fractions={2}
                                                                initialRating={request.operator_rating}/> :
                        <span>NOT RATED</span>}</p>



                </dl>

            </div>

        </div>

        <hr/>

        <MapView onMapLoad={(map) => { }}
                 defaultZoom={7}
                 loadingElement={<div style={{ height: 260 }}/>}
                 defaultOptions={{
                     fullscreenControl: false
                 }}
                 containerElement={<div style={{ height: 260 }} />}
                 mapElement={<div style={{ height: 260 }} />}
                 center={coord}
                 markers={markers}/>

        <hr/>

        {(showCommission || showIncome) && <ExpanderView className="mb-3" title={<h6 style={{display: "inline"}}><i className="fa fa-money"/> Income</h6>} isExpanded={true}>


            <SectionedList items={[
                {
                    title: "Commission",
                    value: <CurrencyLabel currency={request.txn_currency} value={request.commission}/>
                },
                {
                    title: "Income Revenue",
                    value: <CurrencyLabel currency={request.txn_currency} value={request.payout}/>
                },
                {
                    title: "Payments Received",
                    value:  request.payments_issued ? <CurrencyLabel currency={request.txn_currency}
                                          value={_.sumBy(request.payments_issued.filter(x => x.status === RequestPaymentStatus.Success),x => x.amount)}/> : null
                }
            ]}/>


        </ExpanderView>}

        <ExpanderView className="mb-3" title={<h6 style={{display: "inline"}}><i className="fa fa-bar-chart"/> Statistics</h6>} isExpanded={true}>

            <SectionedList items={[
                {
                    title: <span><i className="fa fa-calendar"/> Time Assigned</span>,
                    value: _.isNil(request.date_assigned) ? <h6 style={{ display: "inline" }}><Badge pill>NOT ASSIGNED</Badge></h6> : <TimeAgo id="date_assigned" date={request.date_assigned} style={{ display: "inline" }}/>
                },
                {
                    title: <span><i className="fa fa-calendar"/> Start Time</span>,
                    value: _.isNil(request.date_started) ? <h6 style={{ display: "inline" }}><Badge pill>NOT STARTED</Badge></h6> : <TimeAgo id="date_started" date={request.date_started} style={{ display: "inline" }}/>
                },
                {
                    title: <span><i className="fa fa-calendar"/> Completed</span>,
                    value: _.isNil(request.date_completed) ?  <h6 style={{ display: "inline" }}><Badge pill>NOT COMPLETED</Badge></h6> : <TimeAgo id="date_completed" date={request.date_completed} style={{ display: "inline" }}/>
                },
                {
                    title: <span><i className="fa fa-clock-o"/> Duration</span>,
                    value: _.isNil(request.date_completed) ?  <span>REQUEST NOT COMPLETED</span> : Utils.formatDuration(request.date_assigned,request.date_completed)
                }
            ]}/>

        </ExpanderView>

        {showOperator && request.tractor_operator && <ExpanderView className="mb-3" title={<h6 style={{display: "inline"}}><i className="fa fa-user"/> Tractor Operator/Driver</h6>} isExpanded={false}>

            <div className="row">

                <div className="col-md-6">
                    <dl>

                        <dt>Name</dt>
                        <dd>
                            <HistoryLink url={`/operators?filter_id=${request.tractor_operator.id}&q=${request.tractor_operator.name}`} tooltip={"Click to see operator"} className="btn-link" onClick={toggle}>{request.tractor_operator.name}</HistoryLink>
                        </dd>

                    </dl>
                </div>

                <div className="col-md-6">
                    <dl>

                        <dt>Phone</dt>
                        <dd>{request.tractor_operator.phone}</dd>

                    </dl>
                </div>
            </div>

        </ExpanderView>}

        {request.tractor && <ExpanderView className="mb-3" title={<h6 style={{display: "inline"}}>{HTML.renderIcon('tractor')} Assigned Tractor</h6>} isExpanded={false}>

            <div className="row">

                <div className="col-md-6">
                    <dl>

                        <dt>Name</dt>

                        <dd>
                            <HistoryLink url={`/tractors?filter_id=${request.tractor.id}&q=${request.tractor.name}`} tooltip="Click to see tractor" className="btn-link" onClick={toggle}>{request.tractor.name}</HistoryLink>
                        </dd>

                        <dt>Chassis</dt>
                        <dd>{request.tractor.chassis}</dd>

                    </dl>
                </div>

                <div className="col-md-6">
                    <dl>

                        <dt>Registration No.</dt>
                        <dd>{request.tractor.registration_number}</dd>

                        <dt>Model</dt>
                        <dd>{request.tractor.tractor_model}</dd>

                    </dl>
                </div>

            </div>

        </ExpanderView>}

    </div>

};


// WEBPACK FOOTER //
// ./src/views/Acreage/AcreageCommon.js